import { DropDownList } from '@progress/kendo-react-dropdowns'
import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import React, { FunctionComponent, useRef, useState } from 'react'
import { TicketApi } from '../../../redux/api/TicketApi'
import { Label, Hint } from "@progress/kendo-react-labels";
import { Popup } from '@progress/kendo-react-popup';
import { Menu, MenuItemModel } from '@progress/kendo-react-layout';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { DateTimePicker } from '@progress/kendo-react-dateinputs';
import { IStatus } from '../../../types/Ticket/Status/IStatus';
import { IAutoCloseSetting, IAutoOpenSetting } from '../../../types/Ticket/ITicket';
import ReactTimeAgo from 'react-timeago';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import * as svg from '@progress/kendo-svg-icons';
import { useCurrentUserContext } from '../../../context/UserContext';
const StatusList: FunctionComponent<FieldRenderProps> = props => {
  const {
    label,
    id,
    valid,
    disabled,
    statusId,
    statusName,
    autoOpenSettings,
    autoCloseSettings,
    optional,
    onChange,
    statusNameOnly,
  } = props;

  const navigate = useNavigate();
  const { ticketId } = useParams();
  const { data: ticketDetails } = TicketApi.useGetTicketDetailsQuery({ ticketId: parseInt(ticketId) }, { skip: !ticketId });
  const { data } = TicketApi.useGetMyStatusesQuery();
  const defaultStatusOrCurrent = data?.map(s => {
    if (statusId) return s.Statuses.find(ss => ss.Id === statusId);
    return s.Statuses.find(ss => ss.Open_Default)
  }).find(s => s);

  const defaultOpenStatus = data?.map(s => { return s.Statuses.find(ss => ss.Open_Default) }).find(s => s);
  const defaultClosedStatus = data?.map(s => { return s.Statuses.find(ss => ss.Closed_Default) }).find(s => s);
  const defaultOnHoldStatus = data?.map(s => { return s.Statuses.find(ss => ss.OnHold_Default) }).find(s => s);

  const defaultStatusIdOrCurrent = statusId ? statusId : defaultStatusOrCurrent?.Id;
  const selectedStatus = data?.map((t) => { //return {Type:t.Name, Name:t.Statuses.find(s=>s.Id === defaultStatusIdOrCurrent)?.Name}}
    var stat = t.Statuses.find(s => s.Id === defaultStatusIdOrCurrent)
    if (stat)
      return statusNameOnly ? stat.Code : (t.Name + ' > ' + stat.Name);
    else
      return statusName;
  }).find(s => s);
  //console.log('selectedStatus', statusId, defaultStatusOrCurrent);

  const [show, setShow] = useState(false);
  const offSet = useRef({
    left: 0,
    top: 0,
  });
  const onClick = (e) => {
    offSet.current = {
      left: e.nativeEvent.x,
      top: e.nativeEvent.y,
    };
    setShow(!show);
  };

  const popRef = useRef(null);
  const dropRef = useRef(null);
  window.onclick = (e) => {
    //Check whether the user clicked out of the menu
    if (popRef?.current?.element && dropRef?.current?.element && !popRef.current.element.contains(e.target) && !dropRef.current.element.contains(e.target)) {
      setShow(false);
    }
  }

  const itemSelected = (e) => {

    let statusTypeClicked = e.item.items
    //find the default open, on hold or closed status based on the categor that was clicked
    let selectedStatusId = e.item.id;
    if (statusTypeClicked && selectedStatusId === 1) //default open status
      selectedStatusId = defaultOpenStatus?.Id
    else if (statusTypeClicked && selectedStatusId === 2) //default on hold status
      selectedStatusId = defaultOnHoldStatus?.Id
    else if (statusTypeClicked && selectedStatusId === 0) //default closed status
      selectedStatusId = defaultClosedStatus?.Id
    else if (statusTypeClicked && selectedStatusId === 4) //No auto close default status
      return


    let selectedStatus = data?.map(s => { return s.Statuses.find(ss => ss.Id === selectedStatusId) }).find(s => s);
    console.log('itemSelected', selectedStatus, selectedStatusId)

    //Show the Date prompt for auto close
    //V25.6 - only if there IS NO OTHER CLOSE  ticket validation. Otherwise show the vaLIDATION popup.
    if (selectedStatus?.Auto_Status_Interval === 4 && ticketDetails?.CloseValidationCodes?.filter(c => c !== -7).length > 0) {
      navigate(`/ticket/${ticketId}/close/${selectedStatusId}`);
      return;
    }

    if (selectedStatus?.Auto_Status_Interval === 4) {
      setAutoCloseStatus(selectedStatus);
      setAutoCloseDate(null);
      setShowDatePrompt(true);
      return;
    }

    //console.log('itemSelected', selectedStatus, e.item);
    onChange({ value: { status: (selectedStatus ? { Call_Status: selectedStatus.Name, ID: selectedStatus.Id, Open_status: selectedStatus.Open_Status } as IStatus : null) } });

    setShow(false);
  };
  const [autoCloseStatus, setAutoCloseStatus] = useState(null);
  const [autoCloseDate, setAutoCloseDate] = useState(null);
  const autoCloseDateOk = (e) => {
    if (autoCloseStatus) {
      let selectedStatus = data?.map(s => { return s.Statuses.find(ss => ss.Id === autoCloseStatus.Id) }).find(s => s);
      //console.log('itemSelected', autoCloseStatus.Id, autoCloseDate);
      autoCloseStatus?.Open_Status === 2
        ? onChange({ value: { autoOpenSettings: { Enabled: true, Auto_Open_Date: autoCloseDate } as IAutoOpenSetting, status: (selectedStatus ? { Call_Status: selectedStatus.Name, ID: selectedStatus.Id, Open_status: selectedStatus.Open_Status } as IStatus : null) } })
        : onChange({ value: { autoCloseSettings: { Enabled: true, Auto_Close_Date: autoCloseDate } as IAutoCloseSetting, status: (selectedStatus ? { Call_Status: selectedStatus.Name, ID: selectedStatus.Id, Open_status: selectedStatus.Open_Status } as IStatus : null) } })
    }
    setShow(false)
    setShowDatePrompt(false);
  }
  const anchor = useRef();
  //No Empties statuses
  const statusItems = data?.filter(s => s.Id !== 3).map((t) => {
    const subItems = t.Statuses?.map((s) => {
      return {
        id: s.Id, text: s.Name,
        icon: s.Id === defaultStatusIdOrCurrent ? 'check' : 'blank',
      }
    })

    return {
      id: t.Id,
      text: t.Name,
      //svgIcon: subItems.find(s => s.id === defaultStatusIdOrCurrent) ? svg.checkIcon : null,
      items: subItems,
      icon: subItems.find(s => s.id === defaultStatusIdOrCurrent) ? 'check' : 'blank',
    } as MenuItemModel
  });

  const [showDatePrompt, setShowDatePrompt] = React.useState(false);
  const toggleDialog = () => {
    setShowDatePrompt((curValue) => !curValue);
  };
  const { profile: userProfile } = useCurrentUserContext();

  return (
    <>
      <FieldWrapper >
        {label && <Label
          editorId={id}
          editorValid={valid}
          editorDisabled={disabled}
          optional={optional}
        >
          {label}
        </Label>}
        <div className={"k-form-field-wrap"} ref={anchor}>
          {/* <DropDownList  popupSettings={{className:'z500'}} onChange={onChange} value={selectedStatus?.length > 0 ? selectedStatus[0] : null} data={data} textField={"Call_Status"} dataItemKey={"ID"}/> */}
          <DropDownList ref={dropRef} opened={false} onOpen={onClick} value={selectedStatus} title={selectedStatus} />
          <Popup ref={popRef} anchor={anchor.current} show={show} offset={offSet.current} className='z500' style={{ width: 200 }}>
            <Menu items={statusItems} vertical={true} onSelect={itemSelected} style={{ display: "inline-block" }} className='z500 ticket-context' />
          </Popup>
          {(autoCloseSettings?.Auto_Close_Date) &&
            <Hint id="status_hint">
              <span className={'k-text-success'}>
                Auto close <ReactTimeAgo date={autoCloseSettings?.Auto_Close_Date} />
              </span>
            </Hint>
          }
          {(autoOpenSettings?.Auto_Open_Date) &&
            <Hint id="status_hint">
              <span className={'k-text-success'}>
                Un-pause <ReactTimeAgo date={autoOpenSettings?.Auto_Open_Date} />
              </span>
            </Hint>
          }
        </div>
        {showDatePrompt && (
          <Dialog className='cool-window' title={autoCloseStatus?.Open_Status === 2 ? "On hold until..." : "Auto-Close On..."} onClose={toggleDialog}>
            <div
              style={{
                margin: "15px",
              }}
            >
              {autoCloseStatus?.Open_Status === 2
                ? `Select the date when this ${userProfile?.Phrases.CallPhrase} will un-pause and go back to Open status:`
                : `Select the date when this ${userProfile?.Phrases.CallPhrase} will Auto-close:`
              }

            </div>
            <DateTimePicker placeholder='Select date/time' min={new Date()} onChange={(e) => setAutoCloseDate(e.value.toISOString())} />
            <DialogActionsBar>
              <Button size='medium' disabled={!autoCloseDate} svgIcon={svg.checkIcon} onClick={autoCloseDateOk} style={{ backgroundColor: userProfile?.Nav_Hex_Color, color: 'white' }}>
                OK
              </Button>
              <Button size='medium' svgIcon={svg.xIcon} fillMode='outline' onClick={toggleDialog}>
                Cancel
              </Button>
            </DialogActionsBar>
          </Dialog>
        )}
      </FieldWrapper>

    </>
  )
}

export default StatusList;